import { auth } from '@/plugins/firebase'

export default {
  methods: {
    async _viewReportWindow (calculatorId, calculationId, token) {
      if (!token) token = await auth.currentUser.getIdToken()
      window.open(`${process.env.VUE_APP_BASE_URL}/${this._viewReportPath(calculatorId, calculationId, token)}`)
    },
    _viewReportPath (calculatorId, calculationId, token) {
      return `view/${calculatorId}/${calculationId}?admin=true&token=${token}`
    }
  }
}
